export default function AdvisorSection() {
  return (
    <section id="about" className="py-16 md:py-24 bg-gradient-to-br from-blue-50 to-green-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left Column - Image */}
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-xl border-4 border-white">
              {/* Professional photo */}
              <img 
                src="/Photo%20from%20Sridhar%20Devarshi.jpg" 
                alt="K Satish - Financial Advisor"
                className="w-full h-full object-cover aspect-[3/4]"
              />
            </div>

            {/* Achievement Badges */}
            <div className="absolute -bottom-6 left-6 right-6 grid grid-cols-2 gap-4">
              <div className="bg-white rounded-xl shadow-lg p-4 text-center">
                <div className="text-2xl font-bold text-blue-600">15+</div>
                <div className="text-xs text-gray-600">Years Exp.</div>
              </div>
              <div className="bg-white rounded-xl shadow-lg p-4 text-center">
                <div className="text-2xl font-bold text-green-600">CERTIFIED</div>
                <div className="text-xs text-gray-600">Advisor</div>
              </div>
            </div>
          </div>

          {/* Right Column - Content */}
          <div>
            <div className="mb-6">
              <span className="inline-block bg-blue-100 text-blue-700 px-4 py-2 rounded-full text-sm font-semibold mb-4">
                Meet Your Advisor
              </span>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                Your Trusted Partner in{' '}
                <span className="text-blue-600">Financial Security</span>
              </h2>
            </div>

            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                Hi, I'm <strong className="text-gray-900">K Satish</strong>, and I've spent over 20 years 
                helping families like yours build financial security and peace of mind.
              </p>

              <p>
                I started this journey because I believe that everyone deserves personalized financial advice 
                that puts their family first—not sales targets or commissions. My approach is simple: 
                <strong className="text-blue-600"> understand your unique needs, recommend the best solutions, 
                and stay with you for the long term</strong>.
              </p>

              <p>
                Whether you're just starting your career, planning for your children's future, or thinking 
                about retirement, I'm here to guide you every step of the way with honest, expert advice.
              </p>
            </div>

            {/* Key Points */}
            <div className="mt-6 space-y-3">
              {[
                'Independent advisor working with 10+ reputed insurance companies',
                'Personalized recommendations based on YOUR needs, not commissions',
                'Lifelong support for claims, renewals, and financial reviews',
              ].map((point, index) => (
                <div key={index} className="flex items-start space-x-3">
                  <svg
                    className="w-6 h-6 text-green-500 flex-shrink-0 mt-0.5"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span className="text-gray-700">{point}</span>
                </div>
              ))}
            </div>

            {/* CTA */}
            <div className="mt-8 flex flex-col sm:flex-row gap-4">
              <a
                href="#contact"
                className="inline-flex items-center justify-center bg-blue-600 text-white px-8 py-4 rounded-xl hover:bg-blue-700 transition-all shadow-md hover:shadow-lg font-semibold"
              >
                Talk Directly with Me
                <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                </svg>
              </a>

              <a
                href="tel:+919248852187"
                className="inline-flex items-center justify-center bg-white text-blue-600 border-2 border-blue-600 px-8 py-4 rounded-xl hover:bg-blue-50 transition-all font-semibold"
              >
                <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                Call Now
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
